(function (angular) {
    'use strict';

    angular.module('Common')
        .factory('permissionTreeConfig', [function () {

            //for every single state we specify a required permissions that are required to display this state
            //if there is no required permission we check for any children to be displayable
            //you can also set display: true as default. In this case state will be accessible no matter if user have permissions or no
            var PermissionsTreeSchema = function () {
                this.main = {
                    display: true,
                    children: {
                        totp: {
                            requiredPermissions: ["mem:usr:totp"]
                        },
                        apiSpaces: {
                            requiredPermissions: ["apis:ro"]
                        },
                        package: {
                            display: true
                        },
                        order: {
                            display: true,
                            requiredPermissions: ["order:ro"]
                        },
                        apiSpace: {
                            requiredPermissions: ["apis:ro"],
                            children: {
                                details: {
                                    requiredPermissions: ["apis:ro", "package:hub"]
                                },
                                channels: {
                                    requiredPermissions: ["chan:w"],
                                    children: {
                                        "push-apple": {
                                            requiredPermissions: ["apis:push:r"]
                                        },
                                        "push-android": {
                                            requiredPermissions: ["apis:push:r"]
                                        },
                                        email: {
                                            requiredPermissions: ["email:r"]
                                        },
                                        sms: {
                                            children: {
                                                inbound: {
                                                    requiredPermissions: ["apis:smsconf:r"]
                                                },
                                                tracking: {
                                                    requiredPermissions: ["apis:smsconf:track:r"]
                                                }
                                            }
                                        },
                                        messenger: {
                                            requiredPermissions: ["fb:r"]
                                        },
                                        customChannels: {
                                            requiredPermissions: ["chan:r"]
                                        },
                                        twitter: {
                                            requiredPermissions: ["twitr:r"]
                                        },
                                        rcs: {
                                            requiredPermissions: ["rcs:r", "rcs:w", "msg:rcs:s", "msg:rcs:i"]
                                        },
                                        "app-messaging": {
                                            children: {
                                                authentication: {
                                                    requiredPermissions: ["apis:auth:r"]
                                                },
                                                push: {
                                                    requiredPermissions: ["apis:push:r"]
                                                }
                                            }
                                        }
                                    }
                                },
                                branch: {
                                    requiredPermissions: ["rule:sets:r", "package:hub"]
                                },
                                dataPreferences: {
                                    requiredPermissions: ["apis:w"],
                                    children: {
                                        retention: {
                                            requiredPermissions: ["apis:ra"]
                                        },
                                        optProfile: {
                                            requiredPermissions: ["apis:ra"],
                                        },
                                        optRule: {
                                            requiredPermissions: ["apis:optout:r"]
                                        }
                                    }
                                },
                                integration: {
                                    children: {
                                        "access-tokens": {
                                            requiredPermissions: ["actkn:r", "package:hub"]
                                        },
                                        webhooks: {
                                            requiredPermissions: ["webhook:r", "package:hub"]
                                        },
                                        "webhookFailures": {
                                            requiredPermissions: ["webhook:r", "package:hub"]
                                        }
                                    }
                                },
                                widget: {
                                    children: {
                                        config: {
                                            requiredPermissions: ["wdgtconf:r"]
                                        },
                                        customization: {
                                            requiredPermissions: ["wdgtconf:r"]
                                        }
                                    }
                                },
                                profiles: {
                                    requiredPermissions: ["prof:ra"],
                                    children: {
                                        search: {
                                            requiredPermissions: ["prof:ra"]
                                        },
                                        audience: {
                                            requiredPermissions: ["prof:s:w"]
                                        },
                                        template: {
                                            requiredPermissions: ["prof:temp:w"]
                                        },
                                        history: {
                                            requiredPermissions: ["prof:ra"]
                                        }
                                    }
                                },

                                profile: {
                                    display: false,
                                    children: {
                                        properties: {
                                            requiredPermissions: ["prof:ra"]
                                        },
                                        devices: {
                                            requiredPermissions: ["prof:ra"]
                                        },
                                        history: {
                                            requiredPermissions: ["prof:msg:ra"]
                                        }
                                    }
                                },
                                broadcastWizard: {
                                    requiredPermissions: ["bdcst:ra", "package:contact"]
                                },
                                existingBroadcasts: {
                                    requiredPermissions: ["bdcst:ra", "package:contact"]
                                },
                                phoneValidation: {
                                    requiredPermissions: ["pnv:r", "package:hub"]
                                },
                                forms: {
                                    children: {
                                        templates: {
                                            requiredPermissions: ["frm:tmpl:r"]
                                        }
                                    }
                                },
                                chat2: {
                                    requiredPermissions: ["chat:ro"],
                                    children: {
                                        chat: {
                                            requiredPermissions: ["chat:ro", "package:contact"],
                                            children: {
                                                start: {
                                                    requiredPermissions: ["chat:ro", "package:contact"],
                                                    children: {
                                                        properties: {
                                                            requiredPermissions: ["chat:ro", "package:contact"]
                                                        }
                                                    }
                                                },
                                                conversation: {
                                                    requiredPermissions: ["chat:ro", "package:contact"],
                                                    children: {
                                                        properties: {
                                                            requiredPermissions: ["chat:ro", "package:contact"],
                                                            children: {
                                                                history: {
                                                                    requiredPermissions: ["prof:msg:ra", "package:contact"]
                                                                },
                                                                link: {
                                                                    requiredPermissions: ["prof:msg:ra", "package:contact"]
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }

                                        },
                                        settings: {
                                            children: {
                                                team: {
                                                    requiredPermissions: ["team:w", "package:contact"],
                                                    children: {
                                                        config: {
                                                            requiredPermissions: ["chat:cfg:w", "package:contact"]
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                },
                                inboundRules: {
                                    children: {
                                        settings: {
                                            requiredPermissions: ["auto:inbound:r"]
                                        }
                                    }
                                },
                                reports: {
                                    children: {
                                        liveChat: {
                                            requiredPermissions: ["anlyt:ro", "chat:cfg:w", "chat:ra"]
                                        },
                                        historicChat: {
                                            requiredPermissions: ["anlyt:ro", "chat:cfg:w", "chat:ra"]
                                        },

                                        broadcast: {
                                            requiredPermissions: ["bdcst:ra", "package:contact"]
                                        },
                                        messagedata: {
                                            requiredPermissions: ["anlyt:ro"]
                                        },
                                        messaging: {
                                            children: {
                                                channels: {
                                                    requiredPermissions: ["anlyt:ro"]
                                                },
                                                channel: {
                                                    requiredPermissions: ["anlyt:ro"]
                                                }
                                            }
                                        },
                                        urlTracking: {
                                            requiredPermissions: ["anlyt:ro"]
                                        },
                                        verify: {
                                            requiredPermissions: ["anlyt:ro"]
                                        }
                                    }
                                },
                                templates: {
                                    requiredPermissions: ["tmpl:r"]
                                },
                                forms: {
                                    requiredPermissions: ["frm:r"]
                                },
                            }
                        },
                        home: {
                            display: true
                        },
                        settings: {
                            children: {
                                "my-profile": {
                                    requiredPermissions: ["mem:usr:ro"]
                                },
                                "company-billing": {
                                    requiredPermissions: ["mem:acc:ro"]
                                },
                                "users": {
                                    requiredPermissions: ["mem:usr:ro"]
                                }
                            }
                        },
                        payments: {
                            children: {
                                "store": {
                                    requiredPermissions: ["bill:pay:r"],
                                    children: {
                                        "wallet": {
                                            requiredPermissions: ["bill:pay:r"]
                                        }
                                    }
                                },
                                "invoices": {
                                    requiredPermissions: ["bill:pay:r"]
                                },
                                "walletHistory": {
                                    requiredPermissions: ["bill:pay:r"]
                                }
                            }
                        }
                    }
                };
                this.chat = {
                    requiredPermissions: ["chat:a"]
                };
                this.smsAdminPortal = {
                    requiredPermissions: ["portal:admin:a"]
                };
                this.cpaasAdminPortal = {
                    requiredPermissions: ["portal:cpaasadmin:a"]
                };
                this.accessDenied = {
                    display: true
                };
                this.login = {
                    display: true
                };
                this.controls = {
                    display: true
                };
                this.register = {
                    display: true
                };
                this.thanks = {
                    display: true
                };
                this.resetPassword = {
                    display: true
                };
                this.emailvalidate = {
                    display: true
                };
                this.error = {
                    display: true
                };
            };

            var fac = {
                PermissionsTreeSchema: PermissionsTreeSchema
            }

            return fac;
        }]);
})(window.angular);

